import { User as SupabaseUser } from '@supabase/supabase-js';
import { UserProfileData } from './types';
import { useUserProfile } from '@/hooks/profile/useUserProfile';

export const useProfileData = (user: SupabaseUser | null) => {
  // Use the dedicated user profile hook - single source of truth
  const { profile, isLoading, error } = useUserProfile();
  
  // Transform to match navbar interface
  const transformedData: UserProfileData = {
    firstName: profile.firstName,
    lastName: profile.lastName,
    profilePictureUrl: profile.profilePictureUrl,
    email: profile.email || user?.email || '',
    userRole: profile.userRole
  };

  return { 
    profileData: transformedData,
    isLoading,
    error
  };
};
